console.log('[CartSync Globo] loaded');

(function () {
  const COUNT_SEL = '.cart-bubble__text-count[data-testid="cart-bubble"]';
  const BUBBLE_SEL = '.cart-bubble';

  async function refreshHeaderCount() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      // Cargos Globo: lineas del carrito, no productos principales.
      const count = Array.isArray(cart?.items)
        ? cart.items.reduce((total, item) => {
            const title = String(item.product_title || item.title || '').trim().toUpperCase();
            const isGloboAddon = title === 'TIPO DE FUNDA' ||
              title === 'ESCOGE EL ESTILO DE IMPRESION' ||
              title === 'ESCOGE EL ESTILO DE IMPRESIÓN';
            return total + (isGloboAddon ? 0 : Number(item.quantity || 0));
          }, 0)
        : Number(cart?.item_count || 0);

      for (const countEl of document.querySelectorAll(COUNT_SEL)) {
        countEl.textContent = count < 100 ? String(count) : '';
        countEl.classList.toggle('hidden', count === 0);
      }
      for (const bubble of document.querySelectorAll(BUBBLE_SEL)) {
        bubble.classList.toggle('visually-hidden', count === 0);
        const screenReader = bubble.querySelector('.cart-bubble__text > .visually-hidden');
        if (screenReader) {
          const label = screenReader.textContent.replace(/:\s*\d+\+?\s*$/, '').trim();
          screenReader.textContent = label + ': ' + count;
        }
      }
      for (const icon of document.querySelectorAll('.header-actions__cart-icon')) {
        icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      }
      try {
        sessionStorage.setItem('cart-count', JSON.stringify({
          value: String(count), timestamp: Date.now()
        }));
      } catch (_) {}
    } catch (_) {}
  }

  // Globo hace doble add → refrescamos 2 veces
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        setTimeout(refreshHeaderCount, 350);
        setTimeout(refreshHeaderCount, 950);
      }
    } catch (_) {}
    return res;
  };

  document.addEventListener('cart:update', () => setTimeout(refreshHeaderCount, 150));
  window.addEventListener('pageshow', () => setTimeout(refreshHeaderCount, 180));
  document.addEventListener('DOMContentLoaded', refreshHeaderCount);
})();
